export const hasImageExtension = (imageName) => {
  return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(imageName)
}
